
        import * as module0 from './controllers/navbar_controller.js';import * as module1 from './controllers/toggle_controller.js'
        const modules = {
            "./controllers/navbar_controller.js": module0,
            "./controllers/toggle_controller.js": module1,
        };
        export default modules;
      